import { TreeTooltip } from '@revelio/ui';

import { useTrackFilterTooltip } from '../../../../next/CustomDash/filters/hooks/useTrackFilterTooltip';
import styles from './PopoutTree.module.css';

interface BranchLabelProps {
  branch: string;
  branchDescription?: string;
}

export const BranchLabel = ({
  branch,
  branchDescription,
}: BranchLabelProps) => {
  const trackTooltip = useTrackFilterTooltip();
  return (
    <div className={styles.branchContainer}>
      <div className={styles.branchLabel}>{branch}</div>
      {branchDescription && (
        <TreeTooltip
          label={branchDescription}
          mt="-1px"
          onOpen={() => trackTooltip('filter_branch_description')}
        />
      )}
    </div>
  );
};
